(function () {
    'use strict';

    class SwifLeafletCtrl {
        constructor ($element, settingsService, swifCartoLeafletService, leafletService) {
            this.$element = $element;
            this.settings = settingsService;
            this.swifCartoLeafletService = swifCartoLeafletService;
            this.leafletService = leafletService;
            this.leafletService.settings = settingsService.app.leaflet;
        }
        _onMapInitialized(map) {
            this.onMapInitialized({map:map});
            this.map = map;
            //map.setMaxBounds(this.settings.app.leaflet.maxBounds);
            //map.options.minZoom = this.settings.app.leaflet.minZoom;
            //map.options.maxZoom = this.settings.app.leaflet.maxZoom;
        }
    }
    SwifLeafletCtrl.$inject = ['$element', 'settingsService', 'swifCartoLeafletService', 'leafletService'];

    angular.module('swif.carto')

    .component('swifLeaflet', {
        template: '<leaflet leaflet-show="$ctrl.leafletShow" on-map-initialized="$ctrl._onMapInitialized(map)">' +
                    '</leaflet>',
        controller: SwifLeafletCtrl,
        bindings: {
            onMapInitialized: '&',
            leafletShow: '<'
        }
    });
})();
